const localBaseUrl = "http://127.0.0.1:8001/api/admin/";
// const localBaseUrl = "https://mobile.irshad.center/api/admin/";
const remoteBaseUrl = window.location.origin + "/api/admin/";
// const remoteBaseUrl = 'https://mobappdev.arshdni.app/api/admin/';
// const remoteBaseUrl = 'http://185.206.134.46/api/admin/';
// export const baseUrl = 'http://192.168.1.233/api/admin/';

export const baseUrl = process.env.NODE_ENV === "development" ? localBaseUrl : remoteBaseUrl;

console.log(process.env.NODE_ENV);
console.log(baseUrl);
